// extracted by mini-css-extract-plugin
module.exports = {"week":"styles_week__3SJpC","day-now":"styles_day-now__3wKjX","day-now__title":"styles_day-now__title__2NRqy","day-now__holiday-note":"styles_day-now__holiday-note__wDdHM"};